<template>
  <ul class="nav-menu-list" v-bind="$attrs" @mouseleave="handleMouseLeave">
    <li class="nav-menu-list-item" v-for="(item, idx) in data" :key="item.id"
        @mouseover="handleTabHover($event, { item, idx })"
        @mouseleave="handleTabLeave"
    >
      <!-- hot图标 -->
      <img v-if="item.name === 'WPS认证'" class="nav-menu-list-item-badge" src="~@/assets/image/icon-hot.svg" alt="" srcset="">

      <lr-link
        :to="item.href"
        :target="item.target"
        :class="{ active: activeIndex === idx }"
        @click="handleContentClick('tab', item.name)"
        >{{ item.name }}</lr-link
      >

      <div
        class="nav-menu-dropdown"
        v-show="item.children && item.children.length && hoverIndex == idx"
        @mouseleave="handleMouseLeave"
      >
        <div class="nav-menu-dropdown-list-wrapper lr-page-container">
          <div
            class="nav-menu-dropdown-list"
            v-for="childList in item.children"
            :key="childList.id"
          >
            <lr-link
              class="nav-menu-dropdown-list-item list-item-title"
              :to="childList.href"
              :target="childList.target"
              @click="handleContentClick('firstclass', childList.name)"
            >
              <img :src="childList.icon" v-show="childList.icon" />
              {{ childList.name }}
            </lr-link>
            <div class="nav-menu-dropdown-list-column">
              <lr-link
                class="nav-menu-dropdown-list-item"
                :to="child.href"
                :target="child.target"
                v-for="child in childList.children"
                :key="child.id"
                @click="handleContentClick('secondclass', child.name)"
              >
                {{ child.name }}
              </lr-link>
            </div>
          </div>
        </div>
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    withBanner: { // 在首页且页面置顶情况下，展示有banner对应的样式
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      hoverIndex: -1, // 鼠标hover时高亮的下标
    }
  },

  computed: {
    activeIndex({ data }) {
      if (!data || !data.length) return -1;
      const findParentVal = (url) => {
        const arr = url.split('/');
        const baseIdx = arr.findIndex((item) => item === 'learning');
        return baseIdx === -1 ? -1 : arr[baseIdx + 1] || '';
      };
      const index = data.findIndex((item) => {
        return findParentVal(item.href) === findParentVal(this.$route.path);
      });

      return index;
    }
  },

  methods: {
    // 上报内容的点击
    handleContentClick(operation, keyword) {
      // 新首页 navbar 展示埋点统计，上报下拉框点击tab文案
      const pathArr = this.$route.path.split('/')
      const sourceIndex = pathArr.findIndex((item) => item === 'learning')
      let sourcePage = 'homepage'

      if (sourceIndex < 0) { // wps认证
        sourcePage = 'other'
      } else {
        sourcePage = pathArr[sourceIndex + 1]
      }

      if (sourcePage.indexOf('course') > -1) {
        sourcePage = 'video'
      } else if (sourcePage.indexOf('office') > -1) {
        sourcePage = 'courses'
      } else if (sourcePage.indexOf('article') > -1) {
        sourcePage = 'article'
      } else if (sourcePage.indexOf('question') > -1) {
        sourcePage = 'qa'
      } else if (sourcePage.indexOf('knowledge') > -1) { // wps认证或企业服务
        sourcePage = 'other'
      } else {
        sourcePage = 'homepage'
      }
      this.$collect.nav_click({ click: 'tab', keyword, page: sourcePage });
      this.$collect.homepageNavigationClick({ operation, keyword });
    },

    // 监听tab的hover，上报下拉框的展示
    handleTabHover(e, { item, idx }) {
      // 新首页 navbar 展示埋点统计，上报下拉框tab文案
      this.$collect.navbarShow({ show: item.name });

      if (!(item.children && item.children.length)) {
        this.$emit('check-menulist-active', false);
        return;
      }

      this.$collect.homepagePulldownlistShow({ source: item.name });

      if (item.children && item.children.length) {
        this.hoverIndex = idx;
        this.$emit('check-menulist-active', true);
      }
    },

    // 鼠标离开选择的tab
    handleTabLeave() {
      this.hoverIndex = -1;
    },

    // 监听tab的leave
    handleMouseLeave() {
      this.$emit('check-menulist-active', false);
    }
  }
};
</script>

<style lang="scss" scoped>
.nav-menu-list {
  display: flex;
  height: 100%;

  &-item {
    position: relative;
    height: 100%;
    > a {
      @include flex-center();
      height: 100%;
      margin: 0 12px;
      font-size: 14px;
      color: #111317;
      position: relative;
      &.active,
      &:hover {
        color: #2C71FA;
        &::after {
          content: '';
          position: absolute;
          left: 0;
          bottom: 0;
          background: #2C71FA;
          width: 100%;
          height: 3px;
        }
      }
    }

    &-badge {
      position: absolute;
      top: 50%;
      right: 10px;
      transform: translate(100%, -100%);
      width: 22px;
      height: 11px;
      margin-top: -7px;
    }
  }
}

.nav-menu-dropdown {
  position: fixed;
  top: 56px;
  border-radius: 0;
  border-top: 1px solid #e8e8e8;
  right: 0;
  width: 100%;
  padding: 0 0 10px 0;
  background: #ffffff;
  box-shadow: 0 6px 12px 0 rgba(0, 0, 0, 0.08);

  &-list-wrapper {
    display: flex;
  }

  &-list {
    width: 25%;
    padding: 20px 0;
    box-sizing: border-box;
  }
  &-list-item {
    @include flex-align-center();
    margin-top: 8px;
    font-size: 14px;
    line-height: 17px;
    color: #333840;
    cursor: pointer;

    > img {
      width: 24px;
      height: 24px;
      margin-right: 8px;
    }

    &.list-item-title {
      margin-top: 0;
      padding-bottom: 13px;
      font-size: 14px;
      line-height: 22px;
      color: #111317;
      position: relative;

      &::after {
        content: '';
        width: 232px;
        position: absolute;
        left: 0;
        bottom: 0;
        height: 1px;
        background: rgba(17, 19, 23, 0.1);
      }
    }

    &:hover {
      color: #5794FF;
    }
    &:active:not(:disabled) {
      color: #1C53D4;
    }
  }
  &-list-column {
    padding-top: 16px;
    min-width: 232px;
    display: flex;
    flex-direction: column;

    .nav-menu-dropdown-list-item {
      // width: 50%;
      margin-top: 0;
      margin-bottom: 12px;
    }
  }
}
</style>
